<style lang="scss" scoped>
img {
  max-width: 100%;
  width: 250px;
  height: 250px;
}

.erotic {
  opacity: 0.8;
  filter: alpha(opacity=80); /* For IE8 and earlier */
  position: absolute;
  top: 70%;
  width: 100%;
  height: 19%;
  transform: rotate(-45deg);
  transform-origin: -20% 55%;
  background-color: $danger;
  color: $white;
}
.img-overlay {
  position: relative;
  max-width: 100%;
  overflow: hidden;
}

.border-2 {
  border-width: 2px !important;
}
</style>
<template>
  <div class="flex-row flex-grow-1 pt-3 pb-3">
    <div class="rounded border shadow p-2 bg-white">
      <h4 class="text-primary">Bilder</h4>
      <div class="d-flex flex-wrap">
        <div
          @click="click($event, image)"
          class="p-1 img-overlay border border-2 m-1"
          v-for="(image, index) in images"
          :key="index"
        >
          <img
            :src="
              image.url +
                '?width=' +
                profileImageSize +
                '&height=' +
                profileImageSize
            "
          />
          <div
            v-if="image.is_erotic"
            class="erotic text-xl text-center text-vcenter"
          >
            Erotisch
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import FriendshipMixin from "@/components/Customer/mixins/Friendship";
import swal from "sweetalert2";
export default {
  mixins: [FriendshipMixin],
  data: () => {
    return {
      modalText: "",
      buttonCallback: null,
      pricePerFriendRequest: Laravel.settings.pricePerFriendRequest,
      currency: Laravel.lang.currency
    };
  },
  props: ["media", "profile"],
  methods: {
    click($event, image) {
      if (this.checkAuth($event)) {
        if (image.is_blured) {
          if (this.friendRequestSent) {
            swal.fire({
              title: "Freundschaftsanfrage bereits gesendet!",
              text:
                "Um dieses Bild sehen zu können, musst du darauf warten, bis das andere Mitglied deine Freundschaftsanfrage angenommen hat.",
              type: "warning",
              confirmButtonColor: "#28a745",
              confirmButtonText: "OK"
            });
          } else {
            swal
              .fire({
                title: "Freundschaftsanfrage senden?",
                text:
                  "Freundschaftsanfrage für " +
                  Laravel.settings.pricePerFriendRequest +
                  " " +
                  Laravel.lang.currency +
                  " senden? Wenn dein Chatpartner deine Anfrage bestätigt hat, sind alle Medien sichtbar.",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#28a745",
                cancelButtonColor: "#d33",
                confirmButtonText: "Ja",
                cancelButtonText: "Nein"
              })
              .then(result => {
                if (result.value) {
                  this.sendFriendRequest();
                }
              });
          }
        } else {
          this.$modal.show("image-modal", { image: image.url });
        }
      }
    },
    checkAuth(event) {
      if (!this.$store.getters["user/auth"]) {
        event.stopPropagation();
        event.preventDefault();

        this.$store.dispatch("publicProfileModal/show", this.$modal);

        return false;
      } else return true;
    }
  },
  computed: {
    otherId() {
      return this.profile.id;
    },
    images() {
      return this.media.filter(media => media.is_image);
    },
    profileImageSize() {
      return Laravel.settings.imagesize.profileImages;
    }
  }
};
</script>
